"use client";

import { useContext } from "react";
import { BuilderFormsContext } from "@/contexts";

export const useBuilderFormsContext = () => {
  const context = useContext(BuilderFormsContext);
  if (!context) {
    return {
      correlationId: "",
    };
  }
  return context;
};
